class StandaloneAPI {
    // prefix = '';
    // clientName = '';
    //
    constructor(prefix, clientName = null) {
        this.prefix = prefix;
        this.clientName = clientName;
    }

    async authenticate() {
        let clientId = localStorage.getItem(`${this.clientName}_client_id`);
        let clientSecret = localStorage.getItem(`${this.clientName}_client_secret`);
        if (clientId && clientSecret) {
            // use json post instead of axios

            const result = await jQuery.post('/oauth/token', {
                grant_type: 'client_credentials',
                client_id: clientId,
                client_secret: clientSecret,
            });

            const {
                access_token: accessToken,
                expires_in: expiresIn,
            } = result;

            const expiresAt = new Date();
            expiresAt.setSeconds(expiresAt.getSeconds() + expiresIn);

            localStorage.setItem(`${this.clientName}_access_token`, accessToken);
            localStorage.setItem(`${this.clientName}_expires_at`, expiresAt);

            return Promise.resolve(accessToken);
        } else {
            return Promise.reject('No credentials found');
        }
    }

    async getAccessToken() {
        const expiresAt = localStorage.getItem(`${this.clientName}_expires_at`);
        if (expiresAt) {
            const expiresAtDate = new Date(expiresAt);
            if (expiresAtDate > new Date()) {
                return localStorage.getItem(`${this.clientName}_access_token`);
            }
        }
        return this.authenticate();
    }

    async get(url) {
        const accessToken = await this.getAccessToken();
        return jQuery.ajax({
            url: `${this.prefix}/${url}`,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
    }

    async post(url, data = {}) {
        data._token = jQuery('meta[name="csrf-token"]').attr('content');
        const accessToken = await this.getAccessToken();
        return this.publicPost(url, data, {
            Authorization: `Bearer ${accessToken}`,
        });
    }

    async publicGet(url) {
        return jQuery.ajax({
            url: `${this.prefix}/${url}`,
        });
    }

    async publicPost(url, data = {}, headers = {}) {
        data._token = jQuery('meta[name="csrf-token"]').attr('content');

        // Refresh the csrf token if last refresh was more than 5 minutes ago
        await this.refreshCsrfTokenIfNeeded();

        return jQuery.ajax({
            url: `${this.prefix}/${url}`,
            method: 'POST',
            data,
            headers,
        });
    }

    async refreshCsrfTokenIfNeeded() {
        const csrfTokenRefreshedAt = localStorage.getItem('csrf_token_refreshed_at');
        if (!csrfTokenRefreshedAt || (new Date() - new Date(csrfTokenRefreshedAt)) > 5 * 60 * 1000) {
            await this.refreshCsrfToken();
        }
    }

    async refreshCsrfToken() {
        return new Promise((resolve, reject) => {
            const currentUrl = (new URL(window.location.href)).toString();
            jQuery.ajax({
                url: currentUrl,
                method: 'GET',
            }).then((htmlString) => {
                const csrfToken = htmlString.split('<meta name="csrf-token" content="')[1].split('"')[0];

                if (csrfToken) {
                    localStorage.setItem('csrf_token_refreshed_at', new Date());
                    jQuery('meta[name="csrf-token"]').attr('content', csrfToken);
                    resolve();
                    return;
                }
                console.error('CSRF token not found');
                reject();
            });
        })
    }
}
